export {
    SuiMessageModule,
    IMessage,
    SuiMessage
} from "./index";
